export const MESSAGE_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.MessageWidgetElement';
